module.exports = __webpack_public_path__ + "6a6c4068.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/onboarding.jpg
// module id = 1141
// module chunks = 0 1 2 3 4 5 6 7 8